import { meetingDTO } from "../../types/meeting";
import { demoMembers, demoUserId } from "./members";

const member = (userId: string) =>
  demoMembers.find((m) => m.userId === userId) ?? demoMembers[0];

const now = Date.now();
const hour = 3600000;
const day = 86400000;

const makeMeeting = (
  meetingId: string,
  workgroupId: string,
  workgroupName: string,
  topic: string,
  ownerId: string,
  startTime: Date,
  durationMin: number,
  participantIds: string[],
  openStatus: "OPEN" | "PRIVATE" = "OPEN"
): meetingDTO => {
  const startMs = startTime.getTime();
  return {
    meetingId,
    workgroupId,
    workgroupName,
    occurrenceId: "NONE",
    syncId: null,
    docName: null,
    type: 2,
    topic,
    ownerId,
    startTime: startTime.toISOString(),
    endTime: startMs + durationMin * 60000,
    createTime: startMs - day,
    updateTime: startMs - hour,
    timezone: "Asia/Seoul",
    startUrl: "FAKEURL",
    joinUrl: "FAKEURL",
    password: "demo1234",
    duration: durationMin,
    openStatus,
    hostId: ownerId,
    status: "waiting",
    favorite: "N",
    participantCnt: participantIds.length,
    participantListStr: participantIds.join(","),
    participantList: participantIds.map(member),
    timezoneOffset: 540,
  };
};

const tomorrow = new Date(now + day);
tomorrow.setHours(10, 0, 0, 0);

const dayAfter = new Date(now + 2 * day);
dayAfter.setHours(14, 0, 0, 0);

const nextWeek = new Date(now + 7 * day);
nextWeek.setHours(9, 0, 0, 0);

const yesterday = new Date(now - day);
yesterday.setHours(15, 0, 0, 0);

export const demoMeetings: meetingDTO[] = [
  {
    ...makeMeeting(
      "mtg-001",
      "wg-product-design",
      "Product Design",
      "Q2 Design Review",
      demoUserId,
      tomorrow,
      60,
      [demoUserId, "alice.johnson", "emma.wilson", "kate.davis"]
    ),
    favorite: "Y",
    syncId: "doc-pd-001",
    docName: "Design System Guidelines v2.docx",
  },
  makeMeeting(
    "mtg-002",
    "wg-engineering-core",
    "Engineering Core",
    "Sprint Planning",
    "alice.johnson",
    dayAfter,
    90,
    [demoUserId, "alice.johnson", "bob.chen", "james.brown"]
  ),
  makeMeeting(
    "mtg-003",
    "wg-executive-projects",
    "Executive Projects",
    "Executive Strategy Sync",
    demoUserId,
    nextWeek,
    45,
    [demoUserId, "alice.johnson", "grace.lee", "iris.taylor"],
    "PRIVATE"
  ),
  makeMeeting(
    "mtg-004",
    "wg-marketing-campaign",
    "Marketing Campaign",
    "Campaign Kickoff",
    "carol.smith",
    new Date(now + 3 * day + hour * 2),
    60,
    [demoUserId, "carol.smith", "kate.davis", "mia.rodriguez"]
  ),
  makeMeeting(
    "mtg-005",
    "wg-product-design",
    "Product Design",
    "Usability Test Debrief",
    "emma.wilson",
    new Date(now + 4 * day),
    30,
    [demoUserId, "emma.wilson", "kate.davis"]
  ),
];

/** 워크그룹 ID → 미팅 목록 */
export const demoMeetingsByWorkgroup: Record<string, meetingDTO[]> =
  demoMeetings.reduce(
    (acc, m) => {
      if (!acc[m.workgroupId]) acc[m.workgroupId] = [];
      acc[m.workgroupId].push(m);
      return acc;
    },
    {} as Record<string, meetingDTO[]>
  );
